module.exports = __webpack_public_path__ + "static/media/item_15_6_comp.14fc294c.png";